import React, { useState, useEffect } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { firestore } from "./firebaseConfig";
import { collection, getDocs, deleteDoc, doc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";

function CalendarView() {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [events, setEvents] = useState([]);
  const [selectedDayEvents, setSelectedDayEvents] = useState([]);
  const [showEventList, setShowEventList] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchReservations = async () => {
      const querySnapshot = await getDocs(collection(firestore, "reservations"));
      const fetchedEvents = [];
      querySnapshot.forEach((doc) => {
        const data = doc.data();
        if (data.eventDate) {
          fetchedEvents.push({
            id: doc.id,
            date: new Date(data.eventDate),
            title: data.customerName,
            phone: data.phoneNumber,
            selectedConcept: data.selectedConcept, // ✅ burada field adı doğru
            status: data.status || "hazirlanacak",
          });
        }
      });
      setEvents(fetchedEvents);
    };

    fetchReservations();
  }, []);

  const handleDayClick = (date) => {
    const selected = new Date(date);
    selected.setHours(0, 0, 0, 0);

    const filteredEvents = events.filter((event) => {
      const eventDate = new Date(event.date);
      eventDate.setHours(0, 0, 0, 0);
      return eventDate.getTime() === selected.getTime();
    });

    setSelectedDate(date);
    setSelectedDayEvents(filteredEvents);
    setShowEventList(true);
  };

  const tileContent = ({ date, view }) => {
    if (view === "month") {
      const day = new Date(date);
      day.setHours(0, 0, 0, 0);

      const found = events.find((event) => {
        const eventDay = new Date(event.date);
        eventDay.setHours(0, 0, 0, 0);
        return eventDay.getTime() === day.getTime();
      });

      return found ? (
        <div style={{ color: "#facc15", fontSize: "1.2rem", lineHeight: "1" }}>•</div>
      ) : null;
    }
  };

  const tileClassName = ({ date, view }) => {
    if (view === "month") {
      const day = date.getDay();
      if (day === 0 || day === 6) {
        return "weekend-tile";
      }
    }
    return null;
  };

  const handleDelete = async (eventToDelete) => {
    if (!eventToDelete.id) return alert("Silme için geçerli veri yok.");
    try {
      await deleteDoc(doc(firestore, "reservations", eventToDelete.id));
      setEvents((prev) => prev.filter((e) => e.id !== eventToDelete.id));
      alert("Organizasyon silindi.");
    } catch (err) {
      alert("Silme hatası: " + err.message);
      console.error(err);
    }
  };

  return (
    <div className="calendar-wrapper">
      <button
        onClick={() => navigate(-1)}
        style={{
          margin: "1rem",
          backgroundColor: "#6c757d",
          color: "white",
          border: "none",
          borderRadius: "6px",
          padding: "8px 14px",
          fontSize: "15px",
          fontWeight: "500",
          cursor: "pointer",
        }}
      >
        ◀ Geri Dön
      </button>

      <style>
        {`
          .react-calendar {
            background-color: #1f1f1f;
            color: #f0f0f0;
            border: none;
            border-radius: 12px;
            font-family: 'Quicksand', sans-serif;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);
            padding: 10px;
          }

          .react-calendar__navigation {
            background: transparent;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0 10px;
            margin-bottom: 10px;
          }

          .react-calendar__navigation button {
            background: none;
            border: none;
            color: #facc15;
            font-size: 1.5rem;
            cursor: pointer;
          }

          .react-calendar__navigation button:disabled {
            color: #ccc;
            cursor: default;
          }

          .react-calendar__navigation span {
            flex: 1;
            text-align: center;
            color: #ffffff;
            font-weight: bold;
            font-size: 1.3rem;
          }

          .react-calendar__tile {
            height: 40px;
            width: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: rgb(131, 133, 137) !important;
            font-weight: 600;
          }

          .react-calendar__tile:enabled:hover {
            background-color: #333333;
            color: #facc15;
          }

          .react-calendar__tile--active {
            background: #8b5cf6;
            color: white;
            font-weight: bold;
            border-radius: 50%;
            transform: scale(1.1);
          }

          .react-calendar__month-view__weekdays {
            text-transform: uppercase;
            color: #9ca3af;
            font-size: 0.75rem;
            font-weight: bold;
            padding: 5px 0;
          }

          .event-box {
            background: #252424ff;
            color: #f3f4f6;
            border: 1px solid #444;
            border-radius: 12px;
            padding: 16px;
            margin: 10px;
            box-shadow: 0 6px 18px rgba(49, 125, 84, 0.35);
            width: 280px;
            transition: all 0.2s ease-in-out;
            cursor: pointer;
          }

          .event-box strong {
            font-size: 1.1rem;
            color: #facc15;
          }

          .event-box p {
            margin: 8px 0;
            font-size: 0.95rem;
            color: #d1d5db;
          }

          .event-box:hover {
            background: #2a2a2a;
            transform: translateY(-3px);
          }

          .weekend-tile {
            color: rgb(217, 72, 72) !important;
            font-weight: bold;
          }
        `}
      </style>

      <div className="calendar-title">
        <h2>📅 Tarih Seçimi</h2>
      </div>

      <div className="calendar-box">
        <Calendar
          onChange={setSelectedDate}
          value={selectedDate}
          tileContent={tileContent}
          tileClassName={tileClassName}
          onClickDay={handleDayClick}
        />
      </div>

      <div className="event-list">
        <h3>📋 {selectedDate.toLocaleDateString("tr-TR")} - Etkinlik Listesi</h3>
        {selectedDayEvents.length === 0 ? (
          <p>Bu tarihte organizasyon yok.</p>
        ) : (
          <div style={{ display: "flex", flexWrap: "wrap", gap: "1rem", marginTop: "1rem" }}>
            {selectedDayEvents.map((res, index) => (
              <div
                key={index}
                className="event-box"
                onClick={() => navigate(`/etkinlik/${res.id}`)}
              >
                <h4 style={{ marginBottom: "0.5rem", color: "#facc15" }}>{res.title}</h4>
                <p><strong>Tel:</strong> {res.phone}</p>
                <p><strong>Konsept:</strong> {res.selectedConcept}</p>
                <p>
                  Durum: <span className={`status-badge ${res.status}`}>{res.status}</span>
                </p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default CalendarView;
